import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
// Components
import BrowserTab from '../BrowserTab'
import BrowserTabButton from '../BrowserTabButton'

import {
  setCurrentProxyTab
} from 'app/state/modules/proxy'


const propTypes = {
  baseUrl: PropTypes.string,
  tabs: PropTypes.array,
  onSandboxSetPath: PropTypes.func.isRequired,
}

const defaultProps = {
  baseUrl: '',
  tabs: [],
}

class Browser extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: 0,
      clickedTabs: new Set(),
    }
    if (this.props.onRef) {
      this.props.onRef(this)
    }
    this.onTabClick = this.onTabClick.bind(this)
  }

  componentDidMount() {
    window.addEventListener('message', (event) => {
      if (event.data.action === 'location') {
        this.props.onSandboxSetPath(event.data.pathname, event.data.search)
      }
    }, false)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { clickedTabs } = this.state

    // ititialize clickedTabs with the first tab by default
    if (clickedTabs.size === 0 && nextProps.tabs.length > 0) {
      this.setState({
        clickedTabs: this.state.activeTab.toString(),
      })
      this.setState({ clickedTabs })
    }

    // reset clicked state on sandbox reset
    if (nextProps.baseUrl === '' && nextProps.tabs.length > 0) {
      this.setState({
        clickedTabs: new Set([this.state.activeTab.toString()]),
      })
    }
  }

  onTabClick(tabId) {
    const { clickedTabs } = this.state
    this.props.setCurrentProxyTab(tabId)
    clickedTabs.add(tabId)
    this.setState({
      activeTab: tabId,
      clickedTabs,
    })
  }

  render() {
    const numberOfTabs = this.props.tabs.length
    const tabWidthPixels = (60 / numberOfTabs) + 27
    const tabWidthPercentage = Math.floor(100 / numberOfTabs)
    const tabWidth = `calc(${tabWidthPercentage}% - ${tabWidthPixels}px)`

    let browserHeight = 'calc(100% - 60px)'
    if (this.props.contentType === 'no-proxy') {
      browserHeight = '100%'
    }

    return (
      <div className="uk-section uk-padding-small" style={{ height: browserHeight, paddingBottom: 20 }}>
        <div style={{ height: '100%' }}>
          <div
            style={{
              border: '2px solid #999999',
              borderRadius: 4,
              height: '100%',
              padding: 1,
              background: '#FFFFFF',
            }}
            id="browser"
          >
            <div style={{
              width: 'calc(100% - 20px)',
              height: 40,
              background: '#DDDDDD',
              padding: '10px 10px 0 10px',
            }}
            >

              {(Object.keys(this.props.tabs).length > 0) ? (
                this.props.tabs
                  .sort((a, b) => {
                    return a.sort_order > b.sort_order ? 1 : -1
                  })
                  .map((tab, i) => {
                    if (tab.name !== 'hidden') {
                      return (
                        <BrowserTabButton
                          key={tab.id}
                          active={(this.state.activeTab === Number.parseInt(i, 10))}
                          id={Number.parseInt(i, 10)}
                          name={tab.name}
                          width={tabWidth}
                          handleClick={(tabId) => { this.onTabClick(tabId) }}
                        />
                      )
                    }
                  })
              ) : (
                  <BrowserTabButton
                    active
                    id={0}
                    name="Sandbox"
                    width="calc(100% - 87px)"
                    handleClick={() => { this.setState({ activeTab: 0 }) }}
                  />
                )
              }
            </div>

            {(Object.keys(this.props.tabs).length > 0) ? (
              this.props.tabs
                .sort((a, b) => {
                  return a.sort_order > b.sort_order ? 1 : -1
                })
                .map((tab, i) => {
                  let url = this.props.baseUrl
                  if (
                    (this.props.baseUrl !== '' && this.state.clickedTabs.has(i)) ||
                    (this.props.baseUrl !== '' && tab.load_on_click !== true) ||
                    (this.props.baseUrl !== '' && i === 0)
                  ) {
                    const parts = this.props.baseUrl.split('.')
                    parts[0] = `${parts[0]}_${tab.app_name}`
                    url = parts.join('.')
                  } else if (this.props.baseUrl !== '') {
                    // Don't load the url if the tab hasn't been clicked yet and load_on_click
                    // hasn't been set to true
                    url = ''
                  }
                  let cleanUrl = ''
                  if (this.props.realUrlTabsGenerated && this.props.xApps[`tab${i}`] && this.props.xApps[`tab${i}`].xAppName) {
                    cleanUrl = this.props.proxyTabsData[this.props.xApps[`tab${i}`].xAppName].clean_url
                    if (cleanUrl.trim() === '') {
                      cleanUrl = this.props.xApps[`tab${i}`] && this.props.xApps[`tab${i}`].xAppName && (!tab.clean_url || tab.clean_url === '') ? `https://${this.props.xApps[`tab${i}`].xAppName}` : tab.clean_url
                    }
                  } else {
                    cleanUrl = this.props.xApps[`tab${i}`] && this.props.xApps[`tab${i}`].xAppName && (!tab.clean_url || tab.clean_url === '') ? `https://${this.props.xApps[`tab${i}`].xAppName}` : tab.clean_url
                  }
                  if (cleanUrl.indexOf('http://') < 0 && cleanUrl.indexOf('https://') < 0 && cleanUrl.indexOf('.') > 0) {
                    cleanUrl = `https://${cleanUrl}`
                  }
                  return (
                    <BrowserTab
                      url={url}
                      key={i}
                      active={(this.state.activeTab === Number.parseInt(i, 10))}
                      id={Number.parseInt(i, 10)}
                      proxy={tab.proxy}
                      cleanUrl={cleanUrl}
                      xAppData={this.props.xApps[`tab${i}`] ? this.props.xApps[`tab${i}`] : null}
                      contentType={this.props.contentType}
                      compiling={this.props.compiling}
                    />
                  )
                })
            ) : (
                <BrowserTab
                  url={this.props.baseUrl}
                  active
                  id={0}
                  proxy
                  cleanUrl="http://sandbox-hackedu.com"
                  contentType={this.props.contentType}
                  compiling={this.props.compiling}
                />
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

Browser.propTypes = propTypes
Browser.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  xApps: state.proxy.xApps,
  realUrlTabsGenerated: state.proxy.realUrlTabsGenerated,
  proxyTabsData: state.proxy.tabs,
})

export default withRouter(connect(mapStateToProps, {
  setCurrentProxyTab,
})(Browser))
